export default {
  'table.column.index': '序号',
  'table.column.nickname': '客户姓名',
  'table.column.mobile': '联系电话',
  'table.column.city': '所在城市',
  'table.column.operations': '操作',
  'table.column.master_nickname': '归属人',
  'table.column.master_mobile': '归属人手机号',
  'table.column.master_group': '归属团队',
  'table.column.comsume_status': '消费状态',
  'table.column.last_report_time': '最后报备时间',
  'table.column.next_contact_time': '下次回访时间',
  'table.column.result_level': '回访结果',
  'table.column.content': '回访内容',
  'table.column.updatetime': '回访时间',
  'table.total': '共{total}条',
  'table.column.project': '意向项目',
  'table.column.original_remind_time': '原回访时间',
};
